export const comments_3249783 = {"data":{"data":[],"links":{}}}